import { render, staticRenderFns } from "./CreateNewProject.vue?vue&type=template&id=7be59fb7&"
import script from "./CreateNewProject.vue?vue&type=script&lang=ts&"
export * from "./CreateNewProject.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports